import { Logo2025 } from './Logo2025'

export default Logo2025
